// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {App} from './components/app'
import VueI18n from 'vue-i18n'
import VeeValidate from 'vee-validate'
import de from 'vee-validate/dist/locale/de'
import VueResource from 'vue-resource'
import Moment from 'moment'
import router from './router'
import store from './store'
import './filters/humanBytes'
import './assets/style/app.scss'
import {messages} from './lang/de'
import setupDirectives from './directives'
// Import to ensure webpack bundle
// eslint-disable-next-line no-unused-vars
import FontAwesome from './fontawesome.js'

const locale = 'de'

Vue.config.productionTip = false

Vue.use(VueI18n)

Vue.use(VueResource)

// set up any custom directives
setupDirectives()

Moment.locale(locale)

const i18n = new VueI18n({
  locale: locale,
  messages
})

Vue.use(VeeValidate, {
  i18n,
  dictionary: {
    de
  }
})

// change this to use other superadmin-backends. Live will replace http://superadmin-api.localhost with the production endpoint
// See adjust_env.sh for more info
Vue.http.options.root = 'http://superadmin-api.localhost'
// below supports dev environments, using the *.env files
if (process.env.NODE_ENV !== 'production') {
  if (
    !process.env.API_SCHEME ||
    !process.env.API_HOST ||
    !process.env.API_PORT ||
    !process.env.LOCAL_FRONTEND
  ) {
    console.error(`Missing environment variables. Please run the ${process.env.LOCAL_ENV}.env files.`)
  }
  const port = process.env.API_PORT === '80' ? '' : `:${process.env.API_PORT}`
  Vue.http.options.root = `${process.env.API_SCHEME}://${process.env.API_HOST}${port}`
}

Vue.http.interceptors.push((request, next) => {
  request.credentials = true
  next()
})

const globalStore = new Vue({
  data: {
    message: {
      type: null,
      message: ''
    }
  }
})

Vue.prototype.$globals = globalStore

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js